
// @ts-nocheck
import locale__app_src_i18n_en_json from "../src/i18n/en.json";
import locale__app_src_i18n_fr_json from "../src/i18n/fr.json";
import locale__app_src_i18n_it_json from "../src/i18n/it.json";
import locale__app_src_i18n_de_json from "../src/i18n/de.json";
import locale__app_src_i18n_es_json from "../src/i18n/es.json";
import locale__app_src_i18n_es_XL_json from "../src/i18n/es-XL.json";
import locale__app_src_i18n_pt_br_json from "../src/i18n/pt-br.json";


export const localeCodes =  [
  "en",
  "fr",
  "it",
  "de",
  "es",
  "es-XL",
  "pt-BR"
]

export const localeLoaders = {
  "en": [{ key: "../src/i18n/en.json", load: () => Promise.resolve(locale__app_src_i18n_en_json), cache: true }],
  "fr": [{ key: "../src/i18n/fr.json", load: () => Promise.resolve(locale__app_src_i18n_fr_json), cache: true }],
  "it": [{ key: "../src/i18n/it.json", load: () => Promise.resolve(locale__app_src_i18n_it_json), cache: true }],
  "de": [{ key: "../src/i18n/de.json", load: () => Promise.resolve(locale__app_src_i18n_de_json), cache: true }],
  "es": [{ key: "../src/i18n/es.json", load: () => Promise.resolve(locale__app_src_i18n_es_json), cache: true }],
  "es-XL": [{ key: "../src/i18n/es-XL.json", load: () => Promise.resolve(locale__app_src_i18n_es_XL_json), cache: true }],
  "pt-BR": [{ key: "../src/i18n/pt-br.json", load: () => Promise.resolve(locale__app_src_i18n_pt_br_json), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "files": [
        "/app/src/i18n/en.json"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "files": [
        "/app/src/i18n/fr.json"
      ]
    },
    {
      "code": "it",
      "language": "it-IT",
      "files": [
        "/app/src/i18n/it.json"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "files": [
        "/app/src/i18n/de.json"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "files": [
        "/app/src/i18n/es.json"
      ]
    },
    {
      "code": "es-XL",
      "language": "es-XL",
      "files": [
        "/app/src/i18n/es-XL.json"
      ]
    },
    {
      "code": "pt-BR",
      "language": "pt-BR",
      "files": [
        "/app/src/i18n/pt-br.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "./i18n",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/app/src/i18n/en.json"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": [
      {
        "path": "/app/src/i18n/fr.json"
      }
    ]
  },
  {
    "code": "it",
    "language": "it-IT",
    "files": [
      {
        "path": "/app/src/i18n/it.json"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "files": [
      {
        "path": "/app/src/i18n/de.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": [
      {
        "path": "/app/src/i18n/es.json"
      }
    ]
  },
  {
    "code": "es-XL",
    "language": "es-XL",
    "files": [
      {
        "path": "/app/src/i18n/es-XL.json"
      }
    ]
  },
  {
    "code": "pt-BR",
    "language": "pt-BR",
    "files": [
      {
        "path": "/app/src/i18n/pt-br.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
